<button class="close-button" mat-icon-button (click)="closeClick()">
  <mat-icon>close</mat-icon>
</button>
<h1 mat-dialog-title>Route</h1>
<div mat-dialog-content>
  <iframe
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2430.2169782727005!2d13.332736715674521!3d52.475206979805776!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47a850652d83c2c7%3A0xf233b3e15a9d5734!2sABC+Complett+Ladeneinrichtungs+GmbH+(Ladenbau+Berlin)!5e0!3m2!1sde!2sde!4v1557254037567!5m2!1sde!2sde"
    frameborder="0" style="border:0" allowfullscreen></iframe>
</div>
